import { AxiosResponse, InternalAxiosRequestConfig } from './types'
import { ElMessage } from 'element-plus'
import qs from 'qs'
import { SUCCESS_CODE, TRANSFORM_REQUEST_DATA } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { useStorage } from '@/hooks/web/useStorage'
import { objToFormData } from '@/utils'
const { getStorage } = useStorage('localStorage')

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  const userStore = useUserStoreWithOut()
  const timeZone = getStorage('timeZone') || 'UTC+8'
  // 你在 user.ts 里定义的是 “getters”，在 Pinia 里当作属性访问
  const token = userStore.getToken || userStore.token
  const tokenKey = userStore.getTokenKey || 'Authorization'
  // console.log(JSON.stringify(config))
  config.headers = config.headers || {}
  ;(config.headers as any)['X-Time-Zone'] = timeZone
  if (token) {
    if (!(config.headers as any)[tokenKey]) {
      ;(config.headers as any)[tokenKey] = `Bearer ${token}`
    }
  }
  if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data)
  } else if (
    TRANSFORM_REQUEST_DATA &&
    config.method === 'post' &&
    config.headers['Content-Type'] === 'multipart/form-data' &&
    !(config.data instanceof FormData)
  ) {
    config.data = objToFormData(config.data)
  }
  if (config.method === 'get' && config.params) {
    let url = config.url as string
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      if (config.params[key] !== void 0 && config.params[key] !== null) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
    config.url = url
  }
  // console.log('config', config)
  return config
}

const defaultResponseInterceptors = (response: AxiosResponse) => {
  if (response?.config?.responseType === 'blob') {
    // 如果是文件流，直接过
    return response
  } else if (response.data.code === SUCCESS_CODE || response.data.code === 200) {
    return response.data
  } else if (response.data.code === 401) {
    ElMessage.error(response?.data?.msg)
    const userStore = useUserStoreWithOut()
    userStore.logout()
  } else {
    ElMessage.error(response?.data?.msg)
    // if (response?.data?.code === 401) {
    //   const userStore = useUserStoreWithOut()
    //   userStore.logout()
    // }
  }
}

export { defaultResponseInterceptors, defaultRequestInterceptors }
